import { formatThoughtForSecondsLabel } from '@/services/chatApi'
import { buildCreateAgentQuestionPayload } from './buildCreateAgentQuestionPayload.js'

/**
 * @param {number} thinkingStartedAtMs
 */
export function buildAgentQuestionAssistantMessagePatch(thinkingStartedAtMs) {
  const payload = buildCreateAgentQuestionPayload()
  const endedAt = Date.now()
  return {
    patch: {
      text: '',
      blocks: [],
      agentQuestion: payload,
      agentBrand: payload.agentBrand,
      agentName: payload.agentName,
      thoughtSummary: formatThoughtForSecondsLabel(thinkingStartedAtMs, endedAt),
      createdAt: endedAt,
    },
  }
}
